<template>
  <section class="myhome-con">
<!--    <div class="tab-common">-->
<!--      <ul class="tabmenu">-->
<!--        <li v-for="{svcId, svcNm} in svcs"-->
<!--            :class="currentSvcId == svcId?'current':''"-->
<!--            :key="'svc_' + svcId"-->
<!--            @click="tab_click(svcId)">-->
<!--          <a href="javascript:;">{{svcNm}}</a>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <template v-if="currentSvcId == $cmmn.svc.getSeroiSvcId()">
      <div class="tit-box type1">
        <h1 class="tit-type1">서비스 이용 정보</h1>
        <div>
          <!--
          <btn :txt="'해지'"
               :size="'small'"
               :color="'white'"/>
          -->
          <btn :txt="'과거 세무신고자료 제출'"
              :size="'small'"
              :color="'white'"
              @click="btnTxftStmnDatRgst_click"/>
          <btn v-if="stmnAgncyCnsgStcd == '100'"
               :txt="'신고대리위탁요청'"
               :size="'small'"
               :color="'white'"
               @click="btnStmnAgncyCnsgRqt_click"/>
<!--          <btn :txt="'기초자료업로드'"-->
<!--               :size="'small'"-->
<!--               :color="'white'"-->
<!--               @click="btnBsisDatRgst_click"/>-->
        </div>
      </div>
      <table class="tb-row">
        <colgroup>
          <col style="width:20%;"/>
          <col style="width:auto;"/>
          <col style="width:20%;"/>
          <col style="width:auto;"/>
        </colgroup>
        <tbody>
        <tr>
          <th>서비스이용상태</th>
          <td> {{ svcStpgAt == 'Y'? '중지' : '정상'}}</td>
          <th>서비스{{svcDeTxt}}일자</th>
          <td class="last">{{ $cmmn.date.getYmdFormat(svcDe) }}</td>
        </tr>
        <tr v-if="svcStpgAt == 'Y'">
          <th>서비스중지사유</th>
          <td colspan="3" class="last">{{ svcStpgRsnm }}</td>
        </tr>
        <tr>
          <th>신고대리위탁상태</th>
          <td>{{stmnAgncyCnsgStnm}}</td>
          <th>신고대리위탁{{cnsgStnmTxt}}일자</th>
          <td class="last">{{ $cmmn.date.getYmdFormat(cnsgDe) }}</td>
        </tr>
        <tr v-if="stmnAgncyCnsgStcd == '500'">
          <th>신고대리위탁반려사유</th>
          <td colspan="3" class="last">{{cnsgResnRm}}</td>
        </tr>
        <tr>
          <th>기초자료처리상태</th>
          <td>{{bsisDatPrstNm}}</td>
          <th>기초자료{{bsisDatPrstNmTxt}}일자</th>
          <td class="last">{{ $cmmn.date.getYmdFormat(bsisDatDe) }}</td>
        </tr>
        <tr v-if="stlmMnRgstAt == 'N'">
          <th>정기결제수단</th>
          <td colspan="3"
              class="last">
            <btn :txt="'정기결제수단선택'"
                 :size="'small'"
                 :color="'white'"
                 @click="btnStlmMnRgst_click"/>
            <span class="info1 mgl5">정기결제수단을 선택해 주세요.</span>
          </td>
        </tr>
        <tr v-if="stlmMnRgstAt == 'Y'">
          <th>정기결제수단</th>
          <td colspan="3"
              class="last">
            {{ issuCdcoNm + ' ' + mskngCrdNo }}
            <btn :txt="'삭제'"
                 :size="'ssmall'"
                 :color="'white'"
                 @click="btnStlmMnRemove_click"/>
            <br/>
            <span class="info1">결제 정보 보안을 위하여 상세한 카드번호는 표시되지 않습니다.</span>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="tit-box type1 mgt20">
        <h1 class="tit-type1">서비스 계약 정보</h1>
        <div></div>
      </div>
      <table class="tb-row">
        <colgroup>
          <col style="width:20%;"/>
          <col style="width:auto;"/>
          <col style="width:20%;"/>
          <col style="width:auto;"/>
        </colgroup>
        <tbody>
        <tr>
          <th>서비스계약상태</th>
          <td>{{gdsCntrctStnm}}</td>
          <th>서비스계약{{gdsCntrctDeTxt}}일자</th>
          <td class="last">{{ $cmmn.date.getYmdFormat(gdsCntrctDe) }}</td>
        </tr>
        <tr>
          <th>계약서</th>
          <td colspan="3"
              class="last"
              style="line-height: 25px;">
            <btn :txt="'다운로드'"
                 :size="'ssmall'"
                 :color="'white'"
                 @click="btnCtrtcDwld_click"/>
            <span class="info1 mgl5">계약서 변경은 고객센터(1577-7522)로 연락해주시기 바랍니다.</span>
          </td>
        </tr>
        <tr>
          <th>서비스요금</th>
          <td colspan="3"
              class="last"
              style="line-height: 25px;">
            <btn :txt="'요금제 확인'"
                 :size="'ssmall'"
                 :color="'white'"
                 @click="btnRtstCnrm_click"/>
            <span class="info1 mgl5">요금은 매월 신고 인원에 따라 요금구간이 자동 변경됩니다.</span>
          </td>
        </tr>
        </tbody>
      </table>
      <template v-if="isVrsc">
        <div class="tit-box type1">
          <h1 class="tit-type1">부가서비스 계약 정보</h1>
        </div>
        <table class="tb-row mgt10">
          <colgroup>
            <col style="width:12%;" />
            <col style="width:37%;" />
            <col style="width:12%;" />
            <col style="width:auto;" />
          </colgroup>
          <tbody>
            <tr>
              <th>서비스계약상태</th>
              <td>완료</td>
              <th>서비스 계약일자</th>
              <td class="last">2026-07-01</td>
            </tr>
            <tr>
              <th>계약서</th>
              <td colspan="3"
                  class="last"
                  style="line-height: 25px;">
                <btn :txt="'다운로드'"
                    :size="'ssmall'"
                    :color="'white'"
                    @click="btnCtrtcDwld_click"/>
                <span class="info1 mgl5">계약서 변경은 고객센터(1577-7522)로 연락해주시기 바랍니다.</span>
              </td>
            </tr>
            <tr>
              <th>서비스요금</th>
              <td colspan="3" class="last">
                10,000원
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <div class="tit-box type1">
        <h1 class="tit-type1">서비스 이용료 납부 내역</h1>
        <span class="info1">
          <span class="pc01">매월 이용료는 익월 15일에 결제됩니다.</span>(※주말 및 공휴일은 익영업일에 결제가 이루어집니다.)
        </span>
      </div>
      <div class="search-box">
        <span class="span-form-txt txt-type1">이용기간</span>
        <mcal
            style="width: 130px"
            :ym="svcUscrgMngDlBox.data.srchParams.useBegnYm.value"
            @select="svcUscrgMngDlBox.useBegnYm_select"/>
        <span class="mgl5 mgr5">~</span>
        <mcal
            style="width: 130px"
            :ym="svcUscrgMngDlBox.data.srchParams.useEndYm.value"
            @select="svcUscrgMngDlBox.useEndYm_select"/>
        <btn :txt="'검색'"
             :size="'small'"
             :color="'gray'"
             @click="svcUscrgMngDlBox.btnSrch_click()"/>
      </div>
      <table class="tb-col mgt20">
        <colgroup>
          <col style="width: 100px;">
          <!--          <col style="width: auto;">-->
          <col style="width: auto;">
          <col style="width: auto;">
          <col style="width: auto;">
          <col style="width: 80px;">
          <col style="width: auto;">
          <col style="width: auto;">
          <col style="width: 80px;">
        </colgroup>
        <thead>
        <tr>
          <th>이용년월</th>
          <!--          <th>이용내용</th>-->
          <th>이용금액</th>
          <th>할인금액</th>
          <th>청구금액</th>
          <th>미납여부</th>
          <th>납부금액</th>
          <th>미납금액</th>
          <th class="last">상세보기</th>
        </tr>
        </thead>
        <tbody v-if="svcUscrgMngDlBox.data.dls.value.length > 0">
        <tr v-for="(svcUscrgMngDl) in svcUscrgMngDlBox.data.dls.value"
            :key="'svcUscrgMngDl_' + svcUscrgMngDl.svcUscrgMngSn">
          <td>{{ $cmmn.date.getYmKrFormat(svcUscrgMngDl.stlmCycleVal) }}</td>
          <!--          <td>{{ svcUscrgMngDl.svcUseCn }}</td>-->
          <td class="__right">{{ $cmmn.number.addComma(svcUscrgMngDl.useAmt) }}</td>
          <td class="__right">{{ $cmmn.number.addComma(svcUscrgMngDl.dscntAmt) }}</td>
          <td class="__right" 
          :style="svcUscrgMngDl.chrgeNpyAt == 'Y' && (fcltyTycd == '160' || stlmMnRgstAt == 'N') 
            ? { display:'flex', alignItems:'center', justifyContent:'flex-end', gap:'6px' } 
            : {}">
            <btn
              v-if="svcUscrgMngDl.chrgeNpyAt == 'Y' && (fcltyTycd == '160' || stlmMnRgstAt == 'N')"
              :txt="'결제하기'"
              :color="'purple'"
              @click="btnGnstl_click(svcUscrgMngDl.svcUscrgMngSn, svcUscrgMngDl.lastStlmRqstOrderSn, svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt)"/>
            {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
          </td>
          <td>{{ svcUscrgMngDl.chrgeNpyAt }}</td>
          <template v-if="svcUscrgMngDl.chrgeNpyAt == 'Y'">
            <td class="__right">0</td>
            <td class="__right" style="color: red;">
              {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
            </td>
          </template>
          <template v-if="svcUscrgMngDl.chrgeNpyAt == 'N'">
            <td class="__right">
              {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
            </td>
            <td class="__right">0</td>
          </template>
          <td class="last">
            <btn :txt="'상세'"
                 :size="'ssmall'"
                 @click="svcUscrgMngDlBox.btnShowSvcUscrgDp_click(svcUscrgMngDl.svcUscrgMngSn)"/>
          </td>
        </tr>
        </tbody>
        <tbody v-if="svcUscrgMngDlBox.data.dls.value.length == 0">
        <tr>
          <td class="last" colspan="8">서비스이용요금 청구 내역이 존재하지 않습니다.</td>
        </tr>
        </tbody>
      </table>
      <pagination v-if="svcUscrgMngDlBox.data.paging.value.totCnt > svcUscrgMngDlBox.data.paging.value.listCnt"
                  :paging="svcUscrgMngDlBox.data.paging.value"
                  @move-page="svcUscrgMngDlBox.movePage"/>
    </template>
    <template v-if="currentSvcId == $cmmn.svc.getSeroiLbscSvcId()">
      <div class="tit-box type1 mgt20">
        <h1 class="tit-type1">신청된 노무서비스가 없습니다.</h1>
      </div>
    </template>
  </section>
  <teleport to="body">
    <standard-pay
        ref="standardPayRef"
        @pay="standardPayResult.pay"
        @syserr="standardPayResult.syserr" />
  </teleport>
</template>

<script setup>
import {onMounted, ref, defineProps} from "vue";
import TxftStmnDatCnfm from "@/views/my-home/txft-stmn-dat-cnfm.vue";
import StmnAgncyCnsgRqt from "@/views/my-home/stmn-agncy-cnsg-rqt.vue";
import SeroiRtst from "@/components/seroi-rtst.vue";
import Ctrtcs from "@/views/my-home/ctrtcs.vue";
import {getStore, getUtils} from "@/utils/import";
import SvcUscrgRqstDp from "@/views/my-home/svc-uscrg-rqst-dp.vue";
import SvcStlmMnChng from "@/views/my-home/svc-stlm-mn-chng.vue";
import StandardPay from "@/components/standard-pay.vue";
// import FcltyBsisDats from "@/views/my-home/fclty-bsis-dats.vue";
// import SvcRtstCnfm from "@/views/my-home/svc-rtst-cnfm.vue";

const {$popup, $axios, $cmmn, $alert, $confirm} = getUtils();
const {$loading, $mber, $day} = getStore()

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
});
const standardPayRef = ref(null);
const paySvcUscrgMngSn = ref();
const stlmRqstOrderSn = ref();

const currentSvcId = ref($cmmn.svc.getSeroiSvcId());
const currentSvcNm = ref('');

// 현재 서비스 하나만 존재하여 탭 영역 주석처리
// const tab_click = (svcId) => {
//   currentSvcId.value = svcId;
// };


const gdsCntrctSn = ref();
const svcStpgAt = ref('');
const svcDe = ref('');
const svcDeTxt = ref('시작');
const svcStpgRsnm = ref('');

const getFcltySvcUseDlByFcltySnSvcId = async () => {
  const params = {svcId: currentSvcId.value, fcltySn: props.fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-svc-use-dl/by-fclty-sn-svc-id', {params});

  if (!data) return false;

  gdsCntrctSn.value = data.gdsCntrctSn;
  svcStpgAt.value = data.svcStpgAt;
  svcDe.value = data.svcBegnDe;

  if (data.svcStpgAt == 'Y') {
    svcDe.value = data.svcStpgDe
    svcDeTxt.value = '중지';
  }

  svcStpgRsnm.value = data.svcStpgRsnm;
}

const stmnAgncyCnsgStcd = ref('');
const stmnAgncyCnsgStnm = ref('');
const cnsgDe = ref('');
const cnsgStnmTxt = ref('');
const cnsgResnRm = ref('');

const getFcltyStmnAgncyCnsgDlByFcltySn = async () => {
  const {data} = await $axios.get('/api/svc/fclty-stmn-agncy-cnsg-dl/by-fclty-sn', {params: {fcltySn: props.fcltySn}});
  if (!data) return false;

  stmnAgncyCnsgStcd.value = data.stmnAgncyCnsgStcd;
  stmnAgncyCnsgStnm.value = data.stmnAgncyCnsgStnm;

  let setCnsgDe = '';
  let setCnsgStnm = data.stmnAgncyCnsgStnm;

  if (data.stmnAgncyCnsgStcd == '100') setCnsgStnm = '요청';
  else if (data.stmnAgncyCnsgStcd == '200') setCnsgDe = data.cnsgRqtDe;
  else if (data.stmnAgncyCnsgStcd == '300') {
    setCnsgDe = data.cnsgBegnDe;
    setCnsgStnm = '시작';
  }
  else if (data.stmnAgncyCnsgStcd == '400') setCnsgDe = data.cnsgEndDe;
  else if (data.stmnAgncyCnsgStcd == '500') setCnsgDe = data.cnsgRtrnDe;

  cnsgDe.value = setCnsgDe;
  cnsgStnmTxt.value = setCnsgStnm;
  cnsgResnRm.value = cnsgResnRm;
}

const bsisDatPrstNm = ref('');
const bsisDatPrstNmTxt = ref('제출완료');
const bsisDatDe = ref('');

const getFcltyBsisDatPrcsByFcltySn = async () => {
  const {data} = await $axios.get('/api/svc/fclty-bsis-dat-prcs/by-fclty-sn', {params: {fcltySn: props.fcltySn}});

  let setBsisDatDe = '';
  const bsisDatPrstCd = data.bsisDatPrstCd;
  if (bsisDatPrstCd == '200') setBsisDatDe = data.bsisDatPrsntDe;
  if (bsisDatPrstCd == '300') {
    bsisDatPrstNmTxt.value = data.bsisDatPrstNm;
    setBsisDatDe = data.bsisDatPrstDe;
  }

  bsisDatPrstNm.value = data.bsisDatPrstNm;
  bsisDatDe.value = setBsisDatDe;
}

const fcltyTycd = ref();

const getFcltyByFcltySn = async () => {
  const data = await $cmmn.fclty.getFcltyByFcltySn(props.fcltySn);
  fcltyTycd.value = data.fcltyTycd;
}

const gdsCntrctStnm = ref('');
const gdsCntrctDe = ref('');
const gdsCntrctDeTxt = ref('');
const stlmMnRgstAt = ref('');
const bcrtnoMngSn = ref('');
const issuCdcoNm = ref('');
const mskngCrdNo = ref('');
const bcrtnoRgstDt = ref('');
const bcrtno = ref('');

const getGdsCntrctDlByGdsCntrctSn = async () => {
  const {data} = await $axios.get(
        '/api/svc/gds-cntrct-dl/by-gds-cntrct-sn',
        {params: {gdsCntrctSn: gdsCntrctSn.value}}
    );
  if (!data) return false;

  gdsCntrctStnm.value = data.gdsCntrctStnm;
  gdsCntrctDe.value = data.gdsCntrctDe;

  const isEnd = data.gdsCntrctStcd == '300'
  if (isEnd) {
    gdsCntrctDe.value = data.gdsCntrctEndDe;
    gdsCntrctDeTxt.value = data.gdsCntrctStnm;
  }

  stlmMnRgstAt.value = data.stlmMnRgstAt;
  bcrtnoMngSn.value = data.bcrtnoMngSn;

  if (stlmMnRgstAt.value == 'Y') {
    const { data: getGdsCntrctDlRes} = await $axios.get(
        '/api/stlm/bcrtno-mng-dl/by-bcrtno-mng-sn',
        {params: {bcrtnoMngSn: bcrtnoMngSn.value}}
    );
    issuCdcoNm.value = getGdsCntrctDlRes.issuCdcoNm;
    mskngCrdNo.value = getGdsCntrctDlRes.mskngCrdNo;
    bcrtnoRgstDt.value = getGdsCntrctDlRes.bcrtnoRgstDt;
    bcrtno.value = getGdsCntrctDlRes.bcrtno;
  }
}

const btnTxftStmnDatRgst_click = () => {
  const popupOpts = {
    header: '과거 세무신고자료 제출',
    contentStyle: {
      'width': '900px',
      'max-height': '400px',
      'overflow': 'auto',
    }
  };

  const popupProps = { fcltySn: props.fcltySn };
  const popupEmits = { compt: getFcltyBsisDatPrcsByFcltySn }

  $popup.show(TxftStmnDatCnfm, popupOpts, popupProps, popupEmits);
}

const btnStmnAgncyCnsgRqt_click = () => {
  const popupOpts = {
    header: '신고대리위탁요청',
    contentStyle: {
      'width': '1000px',
      'max-height': '660px',
      'overflow': 'auto',
    }
  };

  const popupProps = { fcltySn: props.fcltySn };
  const popupEmits = { compt: getFcltyStmnAgncyCnsgDlByFcltySn }

  $popup.show(StmnAgncyCnsgRqt, popupOpts, popupProps, popupEmits);
};

// const btnBsisDatRgst_click = () => {
//   const popupOpts = {
//     header: '기초자료',
//     contentStyle: {
//       'width': '900px',
//       'max-height': '400px',
//       'overflow': 'auto',
//     }
//   };
//
//   const popupProps = { fcltySn: props.fcltySn };
//   const popupEmits = { compt: getFcltyBsisDatPrcsByFcltySn }
//
//   $popup.show(FcltyBsisDats, popupOpts, popupProps, popupEmits);
// }

const btnStlmMnRgst_click = async () => {
  try {
    $loading.on();

    // const popupOpts = {
    //   header: '요금제 확인',
    //   contentStyle: {
    //     'width': '700px',
    //   }
    // }
    //
    // const emits = {'rgst': rgstBillCard};
    // const props = {};
    // $popup.show(SvcRtstCnfm, popupOpts, props, emits);

    const popupOpts = {
      header: '정기결제수단 선택',
      contentStyle: {
        'width': '700px',
      }
    }

    const popupProps = { fcltySn: props.fcltySn, gdsCntrctSn: gdsCntrctSn.value};
    const popupEmits = {'rgst': rgstBillCard};

    $popup.show(SvcStlmMnChng, popupOpts, popupProps, popupEmits);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};

const rgstBillCard = async ({bcrtnoMngSn}) => {
  try {
    $loading.on();

    await $axios.post('/api/svc/register-gds-cntrct-dl-stlm-mn', {
      gdsCntrctSn: gdsCntrctSn.value,
      bcrtnoMngSn,
      mberSn: $mber.mberSn
    });
    await $alert('정기결제수단을 등록하였습니다.');

    await getGdsCntrctDlByGdsCntrctSn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};

const btnStlmMnRemove_click = async () => {
  const msg = '결제수단 삭제 시 이용료가 미납될 수 있습니다.<br/>'
      + '(미납 시 서비스 이용이 중지될 수 있습니다.)<br/>'
      + '그래도 삭제하시겠습니까?';
  const isConfirm = await $confirm(msg);

  if (isConfirm) {
    try {
      $loading.on();

      await $axios.post('/api/svc/remove-gds-cntrct-dl-stlm-mn', {
        gdsCntrctSn: gdsCntrctSn.value,
        mberSn: $mber.mberSn
      });

      await $alert('결제수단을 삭제하였습니다.');

      await getGdsCntrctDlByGdsCntrctSn();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  }
};

const isVrsc = ref(false);
const getVrscFcltyChk = async () => {
  const { data } = await $axios.get('/api/vas/vrsc-fclty-chk', {params: {fcltySn: props.fcltySn}});
  isVrsc.value = data;
}

const btnCtrtcDwld_click = () => {
  const popupOpts = {
    header: '계약서 다운로드',
    contentStyle: {
      'width': '800px',
    }
  };

  const popupProps = {gdsCntrctSn: gdsCntrctSn.value};
  $popup.show(Ctrtcs, popupOpts, popupProps);
}

const btnRtstCnrm_click = () => {
  const popupOpts = {
    header: '요금제 확인',
    contentStyle: {
      'width': '700px',
    }
  };

  $popup.show(SeroiRtst, popupOpts);
}

const btnGnstl_click = async (svcUscrgMngSn, lastStlmRqstOrderSn, goodsAmt) => {
  // 청구금액 500원 미만은 계좌이체 불가
  try {
    $loading.on();

    paySvcUscrgMngSn.value = svcUscrgMngSn;
    stlmRqstOrderSn.value = lastStlmRqstOrderSn;
    await showStandardPay(goodsAmt);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const showStandardPay = async (goodsAmt) => {
  const {data: svcs} = await $axios.get('/api/svc/svcs');
  const goodsNm = svcs[0].svcNm;
  const {data: fclty} = await $axios.get('/api/fclty/by-fclty-sn', {params: {fcltySn: props.fcltySn}});
  let fcltyNm = fclty.fcltyNm;
  const fcltyTlno = fclty.fcltyTlno;
  const taxbilRcpnEmail = fclty.taxbilRcpnEmail;
  if (fcltyNm.startsWith('아이사랑꿈터')) {
    // 일반결제 구매자명 30 Byte 제한 이슈로 추가
    fcltyNm = fcltyNm.replace('아이사랑', '').replace(/\s+/g, '');
  }
  
  const payParams = {
    goodsNm,
    ordNo: stlmRqstOrderSn.value,
    goodsAmt: goodsAmt,
    ordNm: fcltyNm,
    ordTel: fcltyTlno,
    ordEmail: taxbilRcpnEmail,
    mbsUsrId: String($mber.mberSn),
  };
  standardPayRef.value.show(payParams);
};

const standardPayResult = {
  pay: async (result) => {
    try {
      $loading.on();
      
      if (result.resultCd == '4000') {
        const rgstStlmPrcsDlParams = {
          stlmRqstOrderSn: stlmRqstOrderSn.value,
          stlmPrcsSecd: '100', // 100: 결제
          stlmPrcsMtcd: '101', // 101: PG사연동
          stlmPrcsMncd: '400', // 400: 계좌이체
          stlmPrcsAmt: result.amt,
          stlmPrcsRm: '',
          stlmPrcsFalrAt: 'N',
          stlmPrcsFalrResn: '',
          pgcoUseAt: 'Y', // PG사 이용여부
          pgcoSecd: '100',
          pgcoNtlkVal: result.tid,
          mberSn: $mber.mberSn
        };
        
        await $axios.post('/api/stlm/rgst-stlm-prcs-dl', rgstStlmPrcsDlParams);

        const modifySvcUscrgMngDlChrgeNpyAtParams = {
          svcUscrgMngSn: paySvcUscrgMngSn.value,
          chrgeNpyAt: 'N',
          mberSn: $mber.mberSn
        };
        await $axios.post('/api/svc/modify-svc-uscrg-mng-dl-chrge-npy-at', modifySvcUscrgMngDlChrgeNpyAtParams);

        await $alert('계좌이체 성공');
      } else {
        await $alert('계좌이체 실패<br/>( [' + result.resultCd + ']' + result.resultMsg + ' )');
      }

      await init();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  syserr: async () => {
    await $alert('결제 실패하였습니다. 관리자에게 문의해 주세요.');
  },
};

const svcUscrgMngDlBox = {
  data: {
    dls: ref([]),
    srchParams: {
      useBegnYm: ref(''),
      useEndYm: ref(''),
    },
    paging: ref({
      listCnt: 5,
      pageCnt: 5,
      nowPageNo: 1,
      totCnt: 0,
    })
  },
  btnSrch_click: async () => {
    try {
      $loading.on();
      const data = svcUscrgMngDlBox.data;
      data.paging.value.nowPageNo = 1;
      const params = svcUscrgMngDlBox.getSrchParams();
      const { svcUscrgMngDls, paging } = await svcUscrgMngDlBox.gets(params);
      svcUscrgMngDlBox.data.dls.value = svcUscrgMngDls;
      svcUscrgMngDlBox.data.paging.value.totCnt = paging.totCnt;

    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  gets: async (params) => {
    const {data} = await $axios.get('/api/svc/svc-uscrg-mng-dls?' + $cmmn.txt.createQueryStr(params));
    return data;
  },
  getSrchParams: () => {
    const data = svcUscrgMngDlBox.data;
    const {useBegnYm, useEndYm} = data.srchParams;
    return {
      stlmCycleBegnVal: useBegnYm.value,
      stlmCycleEndVal: useEndYm.value,
      rqstDcsnAt: 'Y',
      rqstCanclAt: 'N',
      chrgeNpyAt: '',
      svcId: $cmmn.svc.getSeroiSvcId(),
      gdsId: $cmmn.svc.getSeroiBsSvcGdsId(),
      fcltyTycd: '',
      fcltyDpTycd: '',
      sidoCd: '',
      sigunguCd: '',
      srchSe: '',
      srwd: '',
      gdsCntrctSn: gdsCntrctSn.value,
      paging: data.paging.value,
    };
  },
  movePage: async (pageNo) => {
    try {
      $loading.on();
      const data = svcUscrgMngDlBox.data;
      data.paging.value.nowPageNo = pageNo;
      const params = svcUscrgMngDlBox.getSrchParams();
      const { svcUscrgMngDls, paging } = await svcUscrgMngDlBox.gets(params);
      svcUscrgMngDlBox.data.dls.value = svcUscrgMngDls;
      svcUscrgMngDlBox.data.paging.value.totCnt = paging.totCnt;

    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  useBegnYm_select: (e) => {
    const srchParams = svcUscrgMngDlBox.data.srchParams;
    srchParams.useBegnYm.value = e;

  },
  useEndYm_select: (e) => {
    const srchParams = svcUscrgMngDlBox.data.srchParams;
    srchParams.useEndYm.value = e;
  },
  btnShowSvcUscrgDp_click: (svcUscrgMngSn) => {
    const popupOpts = {
      header: '서비스이용료 납부 내역 상세',
      contentStyle: {
        width: '700px',
      }
    };

    const popupProps = {
      svcUscrgMngSn
    }
    const popupEmits = {compt: svcUscrgMngDlBox.btnSrch_click};
    $popup.show(SvcUscrgRqstDp, popupOpts, popupProps, popupEmits);
  },
};

const svcs = ref([]);
const init = async () => {
  const {data} = await $axios.get('/api/svc/svcs');
  svcs.value = data;

  currentSvcId.value = svcs.value[0].svcId;
  currentSvcNm.value = svcs.value[0].svcNm;

  await Promise.all([getFcltySvcUseDlByFcltySnSvcId(), getFcltyStmnAgncyCnsgDlByFcltySn(), getFcltyBsisDatPrcsByFcltySn(), getFcltyByFcltySn(), getVrscFcltyChk()]);
  await getGdsCntrctDlByGdsCntrctSn();

  const begnYmd = $cmmn.date.getAddMtByYmd($day.ymd, -6);
  const endYmd = $day.ymd;
  svcUscrgMngDlBox.data.srchParams.useBegnYm.value = begnYmd.substring(0, 6);
  svcUscrgMngDlBox.data.srchParams.useEndYm.value = endYmd.substring(0, 6);
  await svcUscrgMngDlBox.btnSrch_click();
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
